export class RecaptchaLoader {

    static response;

    static load = () => {

        if (!RecaptchaLoader.response) {
            RecaptchaLoader.response = new Promise((resolve) => {
                const loaderMethod = 'recaptchaLoadedCallback';
                const recaptcha = document.createElement('script');

                recaptcha.src = `https://www.google.com/recaptcha/api.js?onload=${loaderMethod}&render=explicit`;
                recaptcha.async = true;
                recaptcha.defer = true;
                window[loaderMethod] = () => {
                    resolve();
                };
                document.body.appendChild(recaptcha);
            });
        }
        return RecaptchaLoader.response;
    }
}


// WEBPACK FOOTER //
// ./components/recaptcha/RecaptchaLoader.js